import { render, staticRenderFns } from "./LiveSupport.vue?vue&type=template&id=c5b21f40"
import script from "./LiveSupport.vue?vue&type=script&lang=js"
export * from "./LiveSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports